import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) return null;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 bg-white"
      style={{ zIndex: 'var(--iab-z-header)', borderBottom: '0.5px solid var(--iab-border)', height: 'var(--iab-header-height)' }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-full">
        {/* Logo */}
        <Link to="/" data-testid="logo-link" className="flex items-baseline gap-0 select-none" style={{ fontFamily: 'var(--genz-font-display)', fontSize: 'var(--iab-text-xl)', fontWeight: 700, letterSpacing: '-0.02em' }}>
          <span style={{ color: '#16130F' }}>iam</span>
          <span style={{ color: '#C17F24' }}>because</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-7">
          <Link
            to="/"
            data-testid="nav-stories"
            className="transition-colors hover:text-[#0F0F0F]"
            style={{ fontSize: 'var(--iab-text-sm)', fontWeight: 600, color: 'var(--iab-charcoal-soft)' }}
          >
            the whys
          </Link>
          <Link
            to="/icons"
            data-testid="nav-icons"
            className="transition-colors hover:text-[#0F0F0F]"
            style={{ fontSize: 'var(--iab-text-sm)', fontWeight: 600, color: 'var(--iab-charcoal-soft)' }}
          >
            icons
          </Link>
          <Link
            to="/about"
            data-testid="nav-about"
            className="transition-colors hover:text-[#0F0F0F]"
            style={{ fontSize: 'var(--iab-text-sm)', fontWeight: 600, color: 'var(--iab-charcoal-soft)' }}
          >
            about
          </Link>
          <Link
            to="/insights"
            data-testid="nav-insights"
            className="transition-colors hover:text-[#0F0F0F]"
            style={{ fontSize: 'var(--iab-text-sm)', fontWeight: 600, color: 'var(--iab-charcoal-soft)' }}
          >
            insights
          </Link>
          <Link
            to="/mirror"
            data-testid="nav-mirror"
            className="transition-colors hover:text-[#0F0F0F]"
            style={{ fontSize: 'var(--iab-text-sm)', fontWeight: 600, color: 'var(--iab-charcoal-soft)' }}
          >
            the mirror
          </Link>
          <button
            data-testid="nav-talk-to-mira"
            onClick={() => {
              const orb = document.querySelector('[data-testid="mira-orb"]');
              if (orb) orb.click();
            }}
            className="brutal-btn text-sm py-2 px-5"
            style={{ background: '#E91E8C', color: '#fff' }}
          >
            talk it out with mira &rarr;
          </button>
        </nav>

        {/* Mobile Menu Toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white px-6 py-4 space-y-3" style={{ borderTop: '0.5px solid var(--iab-border)' }}>
          <Link to="/" data-testid="mobile-nav-stories" className="block text-sm font-semibold" style={{ color: 'var(--iab-charcoal-soft)' }} onClick={() => setMenuOpen(false)}>the whys</Link>
          <Link to="/icons" data-testid="mobile-nav-icons" className="block text-sm font-semibold" style={{ color: 'var(--iab-charcoal-soft)' }} onClick={() => setMenuOpen(false)}>icons of india</Link>
          <Link to="/about" data-testid="mobile-nav-about" className="block text-sm font-semibold" style={{ color: 'var(--iab-charcoal-soft)' }} onClick={() => setMenuOpen(false)}>about</Link>
          <Link to="/insights" data-testid="mobile-nav-insights" className="block text-sm font-semibold" style={{ color: 'var(--iab-charcoal-soft)' }} onClick={() => setMenuOpen(false)}>insights</Link>
          <Link to="/mirror" data-testid="mobile-nav-mirror" className="block text-sm font-semibold" style={{ color: 'var(--iab-charcoal-soft)' }} onClick={() => setMenuOpen(false)}>the mirror</Link>
          <button data-testid="mobile-nav-talk-to-mira" className="block brutal-btn text-sm text-center py-2.5 w-full" style={{ background: '#E91E8C', color: '#fff' }} onClick={() => { setMenuOpen(false); const orb = document.querySelector('[data-testid="mira-orb"]'); if (orb) orb.click(); }}>talk it out with mira &rarr;</button>
        </div>
      )}
    </header>
  );
}
